import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-pdf.png'
import _imports_1 from '@/assets/images/close.png'


const _withScopeId = n => (_pushScopeId("data-v-49789096"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "closeable-modal"
}
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { style: {"width":"100%","margin":"20px 0","font-size":"16px","font-weight":"bold"} }
const _hoisted_4 = { style: {"width":"100%"} }
const _hoisted_5 = { style: {"width":"210px","margin":"5px 0","font-size":"16px","font-weight":"bold","text-align":"center"} }
const _hoisted_6 = { style: {"display":"flex","width":"100%"} }
const _hoisted_7 = { style: {"width":"100%"} }
const _hoisted_8 = { style: {"width":"200px","margin":"10px 0","font-size":"16px","font-weight":"bold","text-align":"center"} }
const _hoisted_9 = { style: {"display":"flex","width":"100%"} }
const _hoisted_10 = { style: {"display":"flex","width":"100%"} }
const _hoisted_11 = { style: {"display":"flex","width":"100%"} }
const _hoisted_12 = { style: {"display":"flex"} }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "businessLicense-block-section",
  style: {"width":"50px","height":"50px"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-pdf",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  style: {"text-align":"center","line-height":"14px"},
  class: "el-upload__tip"
}
const _hoisted_18 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_19 = {
  key: 0,
  class: "businessLicense-block-section",
  style: {"width":"50px","height":"50px"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-pdf",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  style: {"text-align":"center","line-height":"14px"},
  class: "el-upload__tip"
}
const _hoisted_23 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_24 = {
  key: 0,
  class: "businessLicense-block-section",
  style: {"width":"50px","height":"50px"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-pdf",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  style: {"text-align":"center","line-height":"14px"},
  class: "el-upload__tip"
}
const _hoisted_28 = { style: {"display":"flex"} }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 0,
  class: "businessLicense-block-section",
  style: {"width":"50px","height":"50px"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-pdf",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  style: {"text-align":"center","line-height":"14px"},
  class: "el-upload__tip"
}
const _hoisted_34 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_35 = {
  key: 0,
  class: "businessLicense-block-section",
  style: {"width":"50px","height":"50px"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-pdf",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  style: {"text-align":"center","line-height":"14px"},
  class: "el-upload__tip"
}
const _hoisted_39 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_40 = {
  key: 0,
  class: "businessLicense-block-section",
  style: {"width":"50px","height":"50px"}
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-pdf",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  style: {"text-align":"center","line-height":"14px"},
  class: "el-upload__tip"
}
const _hoisted_44 = {
  key: 7,
  style: {"width":"100%","display":"flex","flex-wrap":"wrap"}
}
const _hoisted_45 = { style: {"width":"100%"} }
const _hoisted_46 = { style: {"width":"210px","margin":"10px 0","font-size":"16px","font-weight":"bold","text-align":"center"} }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "el-dropdown-link",
  style: {"display":"inline-block","height":"1px","width":"300px"}
}, null, -1))
const _hoisted_48 = { class: "businessLicense-block" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-pdf",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "el-upload__text" }
const _hoisted_55 = {
  class: "el-upload__tip",
  style: {"line-height":"14px","display":"none"}
}
const _hoisted_56 = { class: "businessLicense-block" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-pdf",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "el-upload__text" }
const _hoisted_63 = {
  class: "el-upload__tip",
  style: {"line-height":"14px","display":"none"}
}
const _hoisted_64 = { style: {"display":"flex","width":"100%"} }
const _hoisted_65 = { style: {"display":"flex","width":"100%"} }
const _hoisted_66 = { style: {"display":"flex","justify-content":"space-between","max-width":"250px","min-width":"220px","line-height":"32px"} }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-pdf",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "pageBlock-form-btn" }
const _hoisted_72 = {
  key: 0,
  style: {"width":"500px"}
}
const _hoisted_73 = {
  key: 2,
  style: {"font-size":"16px","font-weight":"bold","color":"#00a2e9","margin-left":"200px"}
}
const _hoisted_74 = {
  key: 0,
  style: {"display":"flex","flex":"1"}
}
const _hoisted_75 = { key: 0 }
const _hoisted_76 = {
  key: 1,
  style: {"display":"flex","flex":"1"}
}
const _hoisted_77 = { key: 0 }
const _hoisted_78 = {
  key: 1,
  style: {"width":"500px"}
}
const _hoisted_79 = {
  key: 2,
  style: {"font-size":"16px","font-weight":"bold","color":"#00a2e9","margin-left":"200px"}
}
const _hoisted_80 = {
  key: 0,
  style: {"display":"flex","flex":"1"}
}
const _hoisted_81 = { key: 0 }
const _hoisted_82 = {
  key: 1,
  style: {"display":"flex","flex":"1"}
}
const _hoisted_83 = { key: 0 }
const _hoisted_84 = {
  key: 2,
  style: {"width":"500px"}
}
const _hoisted_85 = { class: "dialog-footer" }

import { reactive, ref, getCurrentInstance, onMounted, nextTick } from 'vue'
import ChangePassword from '@/layout/components/changePassword.vue'
import { ElForm, ElMessage } from 'element-plus'
import type { FormInstance, FormRules, UploadProps } from 'element-plus'
import { Plus, UploadFilled } from '@element-plus/icons-vue'
import { getMeInfo, editMeInfo, getAuthentication, Authenticationcode } from '@/api/myProfile'
import { upload, getCountry, getDictionary, getVerificationCode } from '@/api/common'
import { IMeInfoData, IFileResponse } from '@/types/myProfile'
import { cityAreaList } from '@/assets/data/cityArea'
import { ICountry } from '@/types/common'
import { checkEmail, checkhandPhone, checkMobile, checkTelephone } from '@/utils/formValidate'
import { useRoute, useRouter } from 'vue-router'
import { useMainStore } from '@/stores/main'
import { storeToRefs } from 'pinia'
import axios from 'axios'
import { isArray } from 'element-plus/es/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelConfirmation',
  setup(__props) {

const store = useMainStore()
const { USER_INFO } = storeToRefs(store)
const isVisible = ref(true)

const route = useRoute()
const router = useRouter()
const uploadElement = ref()
const handleChange = () => {
  uploadElement.value.clearValidate()
}
const identityRef = ref()
const identitychange = () => {
  identityRef.value.clearValidate()
}
// 修改密码
const changepwd = ref<boolean>(false)
// 关闭弹窗
const onchange = (params: boolean) => {
  changepwd.value = params
}
// 是否为编辑状态
const isEdit = ref(true)

const { t } = getCurrentInstance()?.appContext.config.globalProperties.$i18n
const formSize = ref('default')
const ruleFormRef = ref<FormInstance>()
const { proxy } = getCurrentInstance() as any
const provinceData = ref<string[] | []>([]) // 选中省市区
const fileUrl = process.env.VUE_APP_OSS_ENDPOINT
// 我的资料数据
const myProfile: IMeInfoData = reactive({
  id: null,
  username: '',
  avatar: '',
  avatarurl: '',
  mobile_zone: '+86',
  name: '',
  identity: '',
  mobile: '',
  email: '',
  wechat: '',
  address: '', // 详细地址
  zipcode: '',
  license: [], // 营业执照 string[]
  company_human_name: '', // 公司法人
  qualificationPhoto: [],
  company: '',
  telephone: '',
  fax: '',
  intro: '', // 备注
  country_id: '', // 国家
  province_id: '', // 省
  city_id: '', // 市
  district_id: '', // 区
  company_email: '',
  allList: [],
  oldemail: '',
  oldmobile: '',
  company_card: '',
  company_usci: '', // 统一社会信用代码
  qualification: [], // 公司资质
  qualifications: [], // 公司资质s
  qualification_others: '',
  mobileCode: '',
  type: '',
  password: '******',
  id_no: '',
  opposite: '',
  passport: '',
  website_source: null,
  id_card: {
    customer_id: '',
    user_name: '',
    id_no: '',
    front: '',
    opposite: '',
    type: '',
    passport: ''
  }
})
// 国外身份证取消校验
const isEnglish = ref(localStorage.getItem('LANG') ? (!(localStorage.getItem('LANG') === 'en')) : false)
// 是否是中国手机号
const isChinaTel = ref(!(localStorage.getItem('LANG') === 'en'))
// 校验函数
const validateInput = (rule: any, value: any, callback: any) => {
  if (/^\d+$/.test(value)) {
    callback(t('myProfile.notnameNumber'))
  } else {
    callback()
  }
}
const rules = reactive<FormRules>({
  password: [
    { required: true, message: t('myProfile.validatePass'), trigger: 'blur' },
    { min: 6, max: 50, message: t('login.PWnum'), trigger: 'blur' }
  ],
  identity_type: [
    { required: true, message: t('myProfile.PLselect'), trigger: 'change' }
  ],
  name: [
    { required: true, message: t('myProfile.validateName'), trigger: 'blur', pattern: '[^ \x22]+' },
    { validator: validateInput, trigger: 'blur' }
  ],
  type: [
    { required: true, message: t('myProfile.PLselect') + t('myProfile.identity'), trigger: 'change' },
    {
      validator: (rule, value, callback) => {
        if (Number(value) === 1) {
          if (!myProfile.front) {
            callback(new Error(t('myProfile.PLuploadfront')))
          }
          if (!myProfile.opposite) {
            callback(new Error(t('myProfile.PLuploadopposite')))
          }
          callback()
        } else if (Number(value) === 2) {
          if (!myProfile.passport) {
            callback(new Error(t('myProfile.PLuploadpassportimg')))
          }
          callback()
        }
      },
      trigger: 'blur'
    }
  ], // 身份证还是护照
  company_usci: [
    { required: true, message: t('myProfile.PLinput') + t('myProfile.compounenyNum'), trigger: 'blur', pattern: '[^ \x22]+' }
  ],
  identity: [
    { required: true, message: t('myProfile.validateIdentity'), trigger: 'change' },
    {
      validator: (rule, value, callback) => {
        if (value === 'IDENTITY_AGENCY' && !myProfile.identity_type) {
          callback(new Error(t('myProfile.selectChannelTypea'))) // 请选择渠道类型
        } else {
          callback()
        }
      }
    }
  ],
  mobile: [{ required: true, message: t('login.mobileError'), trigger: 'blur', pattern: '[^ \x22]+' },
    { validator: checkhandPhone, trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (!myProfile.mobile_zone) {
          callback(new Error(t('myProfile.plecountry')))
        } else {
          callback()
        }
      },
      trigger: 'change'
    },
    {
      validator: isEnglish.value
        ? (rule, value, callback) => {
            if (!myProfile.mobileCode) {
              callback(new Error(t('myProfile.plecode')))
            } else {
              callback()
            }
          }
        : (rule, value, callback) => { callback() },
      trigger: 'blur'
    }
  ],
  mobileen: [
    // { required: true, message: t('login.mobileError'), trigger: 'blur', pattern: '[^ \x22]+' },
    {
      required: true,
      validator: (rule: any, value: any, callback: any) => {
      // const newValue = value.trim()
        const validate = /^[0-9]{6,20}$/
        if (!myProfile.mobile) {
          callback(new Error(t('login.mobileError')))
        } else {
          if (validate.test(myProfile.mobile)) {
            callback()
          } else {
            callback(new Error(t('register.pleaseTrueMobile')))
          }
        }
      },
      trigger: 'blur'
    },
    {
      validator: (rule, value, callback) => {
        if (!myProfile.mobile_zone) {
          callback(new Error(t('myProfile.plecountry')))
        } else {
          callback()
        }
      },
      trigger: 'change'
    },
    {
      validator: isEnglish.value
        ? (rule, value, callback) => {
            if (!myProfile.mobileCode) {
              callback(new Error(t('myProfile.plecode')))
            } else {
              callback()
            }
          }
        : (rule, value, callback) => { callback() },
      trigger: 'blur'
    }
  ],
  email: [
    { required: true, message: t('myProfile.validateEmail'), trigger: 'blur' },
    { validator: checkEmail, trigger: 'blur' }
  ],
  country_id: [
    { required: true, message: t('myProfile.validateCountry'), trigger: 'change' }
  ],
  allList: [
    { required: true, message: t('myProfile.validateProvince'), trigger: 'change' },
    {
      validator: (rule, value, callback) => {
        if (value.length < 3) {
          callback(new Error(t('myProfile.plecompleteprovince')))
        } else {
          const arr = []
          for (let i = 0; i < value.length; i++) {
            const el = value[i]
            if (el) {
              arr.push(true)
            } else {
              arr.push(false)
            }
          }
          if (arr.includes(false)) {
            callback(new Error(t('myProfile.plecompleteprovince'))) // 请选择完整省市区
          } else {
            callback()
          }
        }
      }
    }
  ],
  address: [
    { required: true, message: t('myProfile.validateAddress'), trigger: 'blur', pattern: '[^ \x22]+' }
  ],
  id_no: [
    { required: true, message: t('myProfile.PLidNumber'), trigger: 'blur', pattern: '[^ \x22]+' }
  ],
  zipcode: [
    { required: true, message: t('myProfile.validateZipCode'), trigger: 'blur' },
    {
      validator: (rule: any, value: any, callback: any) => {
        if (value === '') {
          callback(new Error(t('myProfile.validateZipCode')))
        } else {
          const validate = /^(\d){4,6}$/
          if (validate.test(value)) {
            callback()
          } else {
            callback(new Error(t('myProfile.validateZipCodeFormat')))
          }
        }
      },
      trigger: 'blur'
    }
  ],
  company: [
    { required: true, message: t('myProfile.validateCompany'), trigger: 'blur', pattern: '[^ \x22]+' },
    {
      validator: (rule, value, callback) => {
        if (value.length < 5) {
          callback(new Error(t('myProfile.companynamelength')))
        } else {
          callback()
        }
      }
    }
  ],
  company_human_name: [
    { required: true, message: t('myProfile.validateCompanyLegal'), trigger: 'blur', pattern: '[^ \x22]+' }
  ],
  // company_contact_mobile: [
  //   { required: true, message: t('myProfile.plecontactphone'), trigger: 'blur', pattern: '[^ \x22]+' },
  //   {
  //     validator: (rule, value, callback) => {
  //       if (!myProfile.company_contact_mobile_zone) {
  //         callback(new Error(t('myProfile.plecountry')))
  //       } else {
  //         callback()
  //       }
  //     },
  //     trigger: 'change'
  //   }
  // ],
  license: [
    { type: 'array', required: true, message: t('myProfile.validateLicense'), trigger: 'change' }
  ],
  // qualification: [
  //   { type: 'array', required: true, message: t('myProfile.selectcertificateError'), trigger: 'change' },
  //   {
  //     validator: (rule, value, callback) => {
  //       if (value.includes('Other') && !myProfile.qualification_others) {
  //         callback(new Error(t('common.pleaseEnter'))) // 请选择证书
  //       } else {
  //         callback()
  //       }
  //     },
  //     trigger: 'blur'
  //   }
  // ]
  website: [
    // { required: true, message: t('myProfile.plecompanywebsite'), trigger: 'blur', pattern: '[^ \x22]+' },
    {
      validator: (rule, value, callback) => {
        if (value) {
          const reg0 = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/
          const reg = /^[a-zA-Z0-9\-\\.]+\.[a-zA-Z]{2,}$/
          if (!(reg.test(value) || reg0.test(value))) {
            callback(new Error(t('myProfile.websiteError')))
          } else {
            callback()
          }
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  wechat: [
    // { required: true, message: t('myProfile.wechatqq'), trigger: 'blur', pattern: '[^ \x22]+' }
  ],
  telephone: [
    { required: true, message: t('myProfile.plecompanytel'), trigger: 'blur', pattern: '[^ \x22]+' },
    { validator: checkTelephone, trigger: 'blur', pattern: '[^ \x22]+' }
  ],
  company_email: [
    { required: true, message: t('myProfile.plecompanyemail'), trigger: 'blur', pattern: '[^ \x22]+' },
    { validator: checkEmail, trigger: 'blur' }
  ],
  qualification: [
    // { required: true, message: t('myProfile.selectcertificateError'), trigger: 'change' },
    // {
    //   validator: (rule, value, callback) => {
    //     if (value.includes('Other') && !myProfile.qualification_others) {
    //       callback(new Error(t('common.pleaseEnter'))) // 请选择证书
    //     } else {
    //       callback()
    //     }
    //   },
    //   trigger: 'blur'
    // },
    {
      validator: (rule, value, callback) => {
        const isover = []
        for (let i = 0; i < companyQualificationList.value.length; i++) {
          const el = companyQualificationList.value[i]
          for (let j = 0; j < myProfile.qualification.length; j++) {
            const al = myProfile.qualification[j]
            if (el.dicKey === al) {
              if ((myProfile.qualificationPhoto[i] && myProfile.qualificationPhoto[i].length > 0) || al === 'other') {
                isover.push(true)
              } else {
                isover.push(false)
              }
            }
          }
        }
        if (isover.includes(false)) {
          // console.log(isover)
          callback(new Error(t('myProfile.pleuploadcertificate')))
        } else {
          callback()
        }
      },
      trigger: 'change'
    }
  ]
})
// ************************************************************字典***********************************************
const PerstatusList = ref<any>([])
const statusList = ref<any>([])
const statusListChannel = ref<any>([])
// 公司资质
const companyQualificationList = ref<any>([])
// 身份客户字典查询
getDictionary(['customer.identity', 'customer.qualification', 'customer.identity_type.personal', 'customer.identity_type.channel']).then((res: any) => {
  if (res.code === 200) {
    statusList.value = res.data['customer.identity']
    delete statusList.value.PERSONAL
    // companyQualificationList.value = res.data['customer.qualification']
    let i = 0
    for (const key in res.data['customer.qualification']) {
      const value = res.data['customer.qualification'][key]
      const data = {
        dicValue: value,
        dicKey: key,
        isloading: false
      }
      companyQualificationList.value.push(data)
      myProfile.qualificationPhoto[i] = []
      i++
    }
    PerstatusList.value = res.data['customer.identity_type.personal']
    statusListChannel.value = res.data['customer.identity_type.channel']
    selectMeInfo()
  } else {
    ElMessage.error(res.msg)
  }
})
const getUrlParams = (url: string) => {
  const newurl = url.split('?')
  const oldarray = newurl[1].split('&')
  const obj = {}
  for (let i = 0; i < oldarray.length; i++) {
    const arritem = oldarray[i]
    const item = arritem.split('=')
    obj[item[0]] = item[1]
  }
  return obj
}
// 返回
const onBack = async () => {
  const lastPath: any = router.options.history.state.back
  let path = lastPath
  let query = {}
  if (lastPath.indexOf('?') !== -1) {
    path = lastPath.slice(0, lastPath.indexOf('?'))
    query = await getUrlParams(lastPath)
  }
  router.push({
    path,
    query
  })
}
// // 查询国家
// const countryList = ref<ICountry[] | []>([])
// const getCountryList = () => {
//   getCountry().then((res: any) => {
//     if (res.code === 200) {
//       countryList.value = res.data.data
//     } else {
//       ElMessage(res.msg)
//     }
//   })
// }

// *************************************************************获取其他信息***************************************************************
const getotherItem = (key:any) => {
  if (myProfile.qualification_others) {
    if (Array.isArray(myProfile.qualification)) {
      // myProfile.qualification.push(key)
      if (!myProfile.qualification.includes(key)) {
        myProfile.qualification.push(key)
      }
    } else {
      myProfile.qualification = [key]
    }
  }
}
// **************************************************************企业查询相关操作 start****************************************
const dropdown1 = ref()
const componyDataList = ref([])
// 存储静态数据，防止重复查询
const statusData = ref('')
const getComponyDetail = () => {
  if (isEnglish.value) {
    if (myProfile.company.length >= 2 && myProfile.company !== statusData.value) {
      proxy.$API.getCompany({ searchKey: myProfile.company }).then((res:any) => {
        if (res.code === 100200) {
          statusData.value = myProfile.company
          // console.log('res.data = ', res.result.Result)
          if (Number(JSON.parse(res.result).Status) === 200) {
            componyDataList.value = JSON.parse(res.result).Result
            dropdown1.value.handleOpen()
          }
        } else {
          ElMessage.error(res.msg)
        }
      })
    } else {
      dropdown1.value.handleOpen()
    }
  }
}
// **************************************************************企业查询相关操作 end****************************************
// 分配点击数据
const checkCompony = (item:any) => {
  myProfile.address = item.Address
  myProfile.company = item.Name
  // item.No
  myProfile.company_usci = item.CreditCode
  ruleFormRef.value?.validateField(['address', 'company', 'companyUsci'])
  // console.log('item = ', item, statusData.value)
  proxy.$API.getAddress({ address: item.Address }).then((res:any) => {
    if (res.code === 100200) {
      if (JSON.stringify(res.result) !== '{}') {
        myProfile.country_id = res.result.country
        myProfile.allList = res.result.addres
        provinceData.value = res.result.addres
        ruleFormRef.value?.validateField('allList')
      }
    } else {
      ElMessage.error(res.msg)
    }
  })
}
// *******************************************获取国家 **********************************************
// 获取国家列表
const countryData = ref({
  name: '',
  pageNum: 1,
  pageSize: 999
})

const total = ref(0)
const contryList = ref([])
const getContryList = () => {
  if (countryData.value.name) {
    countryData.value.pageNum = 1
  }
  proxy.$API.getDictionary(countryData.value).then((res:any) => {
    // console.log(res)
    if (res.code === 110200) {
      // contryList.value = res.result
      total.value = res.resultSize
      // res.result.forEach((item:any) => {
      //   contryList.value.push(item)
      // })
      contryList.value = res.result
      // contryList.value.forEach(item => {
      //   item.remarks = item.remarks.slice(0, item.remarks.indexOf('/'))
      // })
    }
  })
}
// 图片上传
const request = (param: any) => {
  const data = new FormData()
  data.append('file_name', param.file)
  data.append('field', 'file_name')
  for (const key in param.data) {
    data.append(key, param.data[key])
  }
  upload(data, {
    onUploadProgress: (e: any) => {
      const complete = parseInt(((e.loaded / e.total) * 100) | 0, 10)
      param.onProgress({ percent: complete })
    }
  }).then((res : any) => {
    if (res.code === 200) {
      param.onSuccess(res)
    } else {
      param.onError(res.msg || t('common.unknownError'))
    }
  }).catch(err => {
    param.onError(err)
  })
}
// 筛选省市区
// const bbb = ref()
// const filterMethod = (node, keyword) => {
//   // console.log('filterMethod', node, keyword)
//   // // 只搜索并显示包含关键字的第一级选项
//   // if (node.parent.parent.level === 1) { // 检查节点是否是第一级
//   //   bbb.value = cityAreaList.find(option => option.name.toLowerCase().includes(keyword.toLowerCase()))
//   //   console.log(54, bbb.value)
//   //   // return node.parent.parent.level === 1 && node.parent.parent.label.indexOf(keyword) !== -1
//   //   return node.parent.parent.label.toLowerCase().includes(keyword.toLowerCase())
//   // }
//   // // 对于非第一级选项，不显示
//   // return false
// }
// const keyword1 = ref()
// const beforeFilter = (keyword, resolve) => {
//   keyword1.value = keyword
//   dataouta.value = firstList.value.filter(option => option.label.toLowerCase().includes(keyword1.value.toLowerCase()))
//   // dataouta.value = dataouta.value.filter(v => v.label.indexOf(keyword1.value) > -1)
//   resolve(dataouta.value)
// }
// 选择城市
const onChangeCity = (value: any) => {
  myProfile.province_id = value === null ? '' : value[0]
  myProfile.city_id = value === null ? '' : value[1]
  myProfile.district_id = value === null ? '' : value[2]
}
// **********************************************************获取省市区************************************************
const ProvinceData = ref({
  level: 1,
  name: '',
  parentId: 0
})
const nationalityChange = () => {
  myProfile.allList = []
  ProvinceData.value.level = 1
  ProvinceData.value.parentId = 0
}
// const dataouta = ref([]) // 存储第一级数据
const treelistref = ref()
// const firstList = ref([])
const getCityFn = (node:any, resolve:any) => {
  proxy.$API.getDictionarylist(ProvinceData.value).then((res:any) => {
    // const getCityFn = async (node:any, resolve:any) => {
    //   const res = await proxy.$API.getDictionarylist(ProvinceData.value)
    if (res.code === 110200) {
      const dataout: any = []
      res.result.forEach((item:any) => {
        // const data = {
        //   value: item.code,
        //   label: item.name,
        //   id: item.id,
        //   leaf: node.level >= 2
        // }
        const data = ref({})
        if (localStorage.getItem('LANG') === 'en') {
          data.value = {
            value: item.code,
            label: item.nameEn,
            id: item.id,
            leaf: node.level >= 2
          }
        } else if (localStorage.getItem('LANG') === 'zh_CN') {
          data.value = {
            value: item.code,
            label: item.name,
            id: item.id,
            leaf: node.level >= 2
          }
        }
        // if (node.level === 0) {
        //   dataouta.value = dataout
        //   firstList.value = dataout
        // }
        // dataout.push(data)
        dataout.push(data.value)
      })
      resolve(dataout)
    }
  })
}
const props = reactive({
  // 开启懒加载
  lazy: true,
  value: 'value',
  label: 'label',
  children: 'children',
  // 懒加载加载数据源方法
  async lazyLoad (node:any, resolve:any) {
    const { level } = node
    // console.log(node)
    // 已经有数据了，不需要重复请求了
    if (node.children && node.children.length > 0) return

    // 模拟掉接口
    if (node.level === 0) {
      getCityFn(node, resolve)
    } else if (node.level === 1) {
      ProvinceData.value.level = 2
      ProvinceData.value.parentId = node.data.id
      getCityFn(node, resolve)
    } else if (node.level === 2) {
      ProvinceData.value.level = 3
      ProvinceData.value.parentId = node.data.id
      // contData.value.parentId = node.data.id
      getCityFn(node, resolve)
    }
  }
})
// 查询个人信息
const FormLoading = ref(false)
const selectMeInfo = () => {
  FormLoading.value = true
  getMeInfo().then((res: any) => {
    if (res.code === 200) {
      setMyProfile(res.data)
      const provinceCity = [res.data.province_id, res.data.city_id, res.data.district_id]
      provinceData.value = provinceCity
    } else {
      ElMessage.error(res.msg)
    }
    FormLoading.value = false
    ruleFormRef.value?.clearValidate()
  }).catch(() => {
    FormLoading.value = false
    ruleFormRef.value?.clearValidate()
  })
}
// 获取国家区域号码列表
const countryCodeList = ref([])
const getCountryCodeFn = () => {
  proxy.$API.getCountryCode().then((res: any) => {
    if (res.code === 200) {
      countryCodeList.value = res.data
      for (let i = 0; i < countryCodeList.value.length; i++) {
        const el = countryCodeList.value[i]
        el.label = el.zone_code + ' - ' + el.name
        el.labelen = el.zone_code + ' - ' + el.remarks
      }
    } else {
      ElMessage.error(res.msg)
    }
  })
}
const isFocus = ref(false)
const selectFocus = (visible: any) => {
  isFocus.value = visible
}
onMounted(() => {
  // selectMeInfo()
  // getCountryList()
  getContryList()
  getCountryCodeFn()
})
const id_card = reactive({
  customer_id: myProfile.id,
  user_name: myProfile.name,
  id_no: ''
})
const getMobilezone = () => {
  if (myProfile.mobileZone === '+86') {
    // isEnglish.value = true
    isChinaTel.value = true
  } else {
    isChinaTel.value = false
  }
}
// 是否禁用来源
const sorceDisabled = ref(false)
const setMyProfile = (info: any) => {
  myProfile.id = info.id
  myProfile.username = info.username ? info.username : ''
  myProfile.avatar = info.avatar ? info.avatar : ''
  myProfile.avatarurl = myProfile.avatar ? process.env.VUE_APP_OSS_ENDPOINT + myProfile.avatar : ''
  myProfile.name = info.name ? info.name : ''
  if (info.identity) {
    myProfile.identity = info.identity || ''
  }
  if (info.identity === 'IDENTITY_AGENCY') {
    if (info.qualifications) {
      for (let j = 0; j < companyQualificationList.value.length; j++) {
        const al = companyQualificationList.value[j]
        myProfile.qualificationPhoto[j] = []
        for (let i = 0; i < info.qualifications.length; i++) {
          const el = info.qualifications[i]
          if (al.dicKey === el.job_title) {
            myProfile.qualification.push(el.job_title)
            myProfile.qualificationPhoto[j] = el.qualification_certificate
            if (el.remarks) {
              myProfile.qualification_others = el.remarks
            }
          }
        }
      }
    }
  } else {
    myProfile.qualifications = info.qualifications || []
  }
  myProfile.mobile = info.mobile ? info.mobile : ''
  myProfile.email = info.email ? info.email : ''
  myProfile.wechat = info.wechat ? info.wechat : ''
  myProfile.address = info.address ? info.address : ''
  myProfile.zipcode = info.zipcode ? info.zipcode : ''
  myProfile.license = info.license ? info.license : []
  myProfile.company_human_name = info.company_human_name ? info.company_human_name : ''
  myProfile.company = info.company ? info.company : ''
  myProfile.telephone = info.telephone ? info.telephone : ''
  myProfile.fax = info.fax ? info.fax : ''
  myProfile.intro = info.intro ? info.intro : ''
  myProfile.country_id = info.country_id ? info.country_id : ''
  myProfile.province_id = info.province_id ? info.province_id : ''
  myProfile.website = info.website ? info.website : ''
  myProfile.company_email = info.company_email ? info.company_email : ''
  myProfile.city_id = info.city_id ? info.city_id : ''
  myProfile.district_id = info.district_id ? info.district_id : ''
  myProfile.allList = [myProfile.province_id, myProfile.city_id, myProfile.district_id]
  provinceData.value = [myProfile.province_id, myProfile.city_id, myProfile.district_id]
  myProfile.company_contact_mobile_zone = info.company_contact_mobile_zone ? info.company_contact_mobile_zone : '+86'
  myProfile.company_contact_mobile = info.company_contact_mobile ? info.company_contact_mobile : ''
  myProfile.group_id = info.group_id ? info.group_id : ''
  myProfile.company_card = info.company_card ? info.company_card : ''
  myProfile.type = info.id_card && info.id_card.type ? info.id_card.type : ''
  myProfile.id_no = info.id_card && info.id_card.id_no ? info.id_card.id_no : ''
  myProfile.opposite = info.id_card && info.id_card.opposite ? info.id_card.opposite : ''
  myProfile.front = info.id_card && info.id_card.front ? info.id_card.front : ''
  myProfile.passport = info.id_card && info.id_card.passport ? info.id_card.passport : ''
  myProfile.oldemail = info.email || ''
  myProfile.website_source = info.website_source || null
  myProfile.company_usci = info.company_usci || ''
  myProfile.mobile_zone = info.mobile_zone || '+86'
  myProfile.oldmobile = info.mobile || ''
  // myProfile.qualification = info.qualification || []
  myProfile.personal_resume = info.personal_resume || ''
  myProfile.identity_type = info.identity_type || ''
  // myProfile.qualification_others = info.qualification_others || ''
  myProfile.password = info.password || '******'
  myProfile.id_card = {
    customer_id: myProfile.id,
    user_name: myProfile.name ? myProfile.name : '',
    id_no: info.id_card && info.id_card.id_no ? info.id_card.id_no : '',
    front: info.id_card && info.id_card.front ? info.id_card.front : '',
    opposite: info.id_card && info.id_card.opposite ? info.id_card.opposite : '',
    type: info.id_card && info.id_card.type ? info.id_card.type : '',
    passport: info.id_card && info.id_card.passport ? info.id_card.passport : ''
  }
  // info.mobile_zone = '+77'
  if (localStorage.getItem('LANG') === 'en') {
    isEnglish.value = false
  } else {
    isEnglish.value = true
  }
  if (info.mobile_zone === '+86') {
    isChinaTel.value = true
  } else {
    isChinaTel.value = false
  }
}
// *******************************************************保存******************************************************
// 保存时数据处理
const setData = () => {
  const data = JSON.parse(JSON.stringify(myProfile))
  // console.log(data)
  if (data.country_id !== 'CN') {
    data.province_id = ''
    data.city_id = ''
    data.district_id = ''
  } else {
    if (myProfile.allList && myProfile.allList.length > 0) {
      data.province_id = myProfile.allList[0]
      data.city_id = myProfile.allList[1]
      data.district_id = myProfile.allList[2]
    }
  }
  data.id_card.customer_id = myProfile.id
  data.id_card.front = myProfile.front
  data.id_card.opposite = myProfile.opposite
  data.id_card.passport = ''
  data.id_card.type = myProfile.type
  data.id_card.id_no = myProfile.id_no
  if (data.password === '******') {
    delete data.password
  } else {
    const encryptPass = proxy.$TOOL.crypot.AES.encrypt(
      data.password,
      proxy.$CONFIG.LS_ENCRYPTION_key
    )
    data.password = encryptPass
  }
  if (data.identity && data.identity !== 'IDENTITY_AGENCY' && data.identity !== 'PERSONAL') {
    data.identity_type = ''
  }
  if (data.license && data.license.length > 0) {
    data.license = myProfile.license
  } else {
    data.license = null
  }
  data.id_card.user_name = data.name
  if (data.identity === 'IDENTITY_AGENCY') {
    for (let i = 0; i < companyQualificationList.value.length; i++) {
      const el = companyQualificationList.value[i]
      for (let j = 0; j < myProfile.qualification.length; j++) {
        const al = myProfile.qualification[j]
        if (el.dicKey === al) {
          const dataobj = {
            job_title: al,
            qualification_certificate: data.qualificationPhoto[i]
          }
          if (al === 'other' || al === 'Other') {
            dataobj.remarks = myProfile.qualification_others
          }
          data.qualifications.push(dataobj)
        }
      }
    }
  }
  // datain.wechat = datain.toolAccount
  return data
}
const saveInfo = (data: any) => {
  editMeInfo(data.id, data).then((res: any) => {
    if (res.code === 200) {
      selectMeInfo()
      USER_INFO.value = res.data
      ElMessage({
        message: res.msg,
        type: 'success'
      })
      isVisible.value = false
      pwdDisabled.value = true
    } else {
      ElMessage({
        message: res.msg,
        type: 'error'
      })
    }
    // 完善后跳转之前页面
    if (route.query.from) {
      router.push({
        name: route.query.from as string
      })
    }
  })
}
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid) => {
    if (valid) {
      const data = setData()
      if (isEnglish.value) {
        // console.log('111111')
        const saveCode = {
          mobile: data.mobile,
          verify_type: 1,
          code: data.mobileCode,
          mobile_zone: data.mobile_zone
        }
        Authenticationcode(saveCode).then((res) => {
          if (res.code === 200) {
            saveInfo(data)
          } else {
            ElMessage.error(res.msg)
          }
        })
      } else {
        saveInfo(data)
      }
    } else {
      nextTick(() => {
        const isError = document.getElementsByClassName('is-error')
        isError[0].scrollIntoView({
          // 滚动到指定节点
          // 值有start,center,end，nearest，当前显示在视图区域中间
          block: 'center',
          // 值有auto、instant,smooth，缓动动画（当前是慢速的）
          behavior: 'smooth'
        })
      })
    }
  })
}

// ***************************************************上传头像loading效果**********************************************
const avatarLoading = ref(false)
// 上传头像校验jpg, .bmp, .jpeg, .png, .gif
const beforeAvatarUpload: UploadProps['beforeUpload'] = (rawFile) => {
  const imageType = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg']
  if (imageType.indexOf(rawFile.type) === -1) {
    ElMessage.error(t('myProfile.imgType'))
    return false
  } else if (rawFile.size / 1024 / 1024 > 10) {
    ElMessage.error(t('myProfile.imgSize'))
    return false
  }
  avatarLoading.value = true
  return true
}
// 上传头像
const handleAvatarSuccess: UploadProps['onSuccess'] = (response) => {
  myProfile.avatarurl = response.data.url
  myProfile.avatar = response.data.path
  avatarLoading.value = false
}
const handleAvatarError = () => {
  avatarLoading.value = false
}
// ***************************************************上传身份证正面loading效果**********************************************
const frontLoading = ref(false)
// 上传身份证正面校验jpg, .bmp, .jpeg, .png, .gif
const beforefrontUpload: UploadProps['beforeUpload'] = (rawFile) => {
  const imageType = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg']
  if (imageType.indexOf(rawFile.type) === -1) {
    ElMessage.error(t('myProfile.imgType'))
    return false
  } else if (rawFile.size / 1024 / 1024 > 10) {
    ElMessage.error(t('myProfile.imgSize'))
    return false
  }
  frontLoading.value = true
  return true
}
// 上传身份证正面
const handlefrontSuccess: UploadProps['onSuccess'] = (response) => {
  // myProfile.avatarurl = response.data.url
  myProfile.front = response.data.path
  ruleFormRef.value?.validateField('front')
  frontLoading.value = false
}
const handlefrontError = () => {
  frontLoading.value = false
}
// ***************************************************上传身份证背面loading效果**********************************************
const oppositeLoading = ref(false)
// 上传身份证背面校验jpg, .bmp, .jpeg, .png, .gif
const beforeoppositeUpload: UploadProps['beforeUpload'] = (rawFile) => {
  const imageType = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg']
  if (imageType.indexOf(rawFile.type) === -1) {
    ElMessage.error(t('myProfile.imgType'))
    return false
  } else if (rawFile.size / 1024 / 1024 > 10) {
    ElMessage.error(t('myProfile.imgSize'))
    return false
  }
  oppositeLoading.value = true
  return true
}
// 上传身份证背面
const handleoppositeSuccess: UploadProps['onSuccess'] = (response) => {
  // myProfile.avatarurl = response.data.url
  myProfile.opposite = response.data.path
  if (myProfile.front && myProfile.opposite) {
    ruleFormRef.value?.clearValidate('idPhoto')
  }
  ruleFormRef.value?.validateField('front')
  oppositeLoading.value = false
}
const handleoppositeError = () => {
  oppositeLoading.value = false
}
// ***************************************************上传护照loading效果**********************************************
const passportLoading = ref(false)
// 上传身份证背面校验jpg, .bmp, .jpeg, .png, .gif
const beforepassportUpload: UploadProps['beforeUpload'] = (rawFile) => {
  const imageType = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg']
  if (imageType.indexOf(rawFile.type) === -1) {
    ElMessage.error(t('myProfile.imgType'))
    return false
  } else if (rawFile.size / 1024 / 1024 > 10) {
    ElMessage.error(t('myProfile.imgSize'))
    return false
  }
  passportLoading.value = true
  return true
}
// 上传身份证背面
const handlepassportSuccess: UploadProps['onSuccess'] = (response) => {
  // myProfile.avatarurl = response.data.url
  myProfile.passport = response.data.path
  if (myProfile.front && myProfile.opposite) {
    ruleFormRef.value?.clearValidate('idPhoto')
  }
  passportLoading.value = false
}
const handlepassportError = () => {
  passportLoading.value = false
}
// **********************************************************上传营业执照*******************************************************
const isShowBusinessLoading = ref(false)
const handleLicenseSuccess: UploadProps['onSuccess'] = (response: IFileResponse) => {
  isShowBusinessLoading.value = false
  // 接口无数据是null，不是数组
  if (!Array.isArray(myProfile.license)) {
    myProfile.license = [response.data.path]
    ruleFormRef.value?.clearValidate('license')
  } else {
    if (myProfile.license.length < 5) {
      myProfile.license.push(response.data.path)
    } else {
      ElMessage.error(t('myProfile.licenseLength'))
    }
  }
}
const handleLinceseError = () => {
  isShowBusinessLoading.value = false
}

const dialogImageUrl = ref('')
const dialogVisible = ref(false)

// 删除营业执照
const handleRemove = (index: number) => {
  myProfile.license.splice(index, 1)
}

// 营业执照图片上传之前的钩子
const businessLicenseUpload: UploadProps['beforeUpload'] = (rawFile) => {
  // const imageType = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg', 'image/gif']
  // if (imageType.indexOf(rawFile.type) === -1) {
  //   ElMessage.error(t('myProfile.licenseType'))
  //   return false
  // } else
  if (rawFile.size / 1024 / 1024 > 20) {
    ElMessage.error(t('myProfile.licenseSize'))
    return false
  }
  isShowBusinessLoading.value = true
}
// 浏览器打开pdf
const onOpenPDFFile = (path: string) => {
  window.open(fileUrl + path, '_blank')
}
const close = () => {
  TelAndEmailDialog.value = false
  TelAndEmailDialogRef.value?.resetFields()
  Type.value = ''
  isdisable.value = false
  emailitem.value = false
  telitem.value = false
  isCode.value = false // 是否发送了验证码
  Time.value = 0
  telAndEmailInfo.verify_type = '1'
  telAndEmailInfo.email = ''
  telAndEmailInfo.mobile_zone = '+86'
  telAndEmailInfo.mobile = ''
}
const changeWay = (type:any) => {
  // TelAndEmailDialogRef.value?.resetFields()
  isdisable.value = false // 是否禁用获取验证码按钮
  emailitem.value = false // 邮箱发送验证码提示语
  telitem.value = false // 手机发送验证码提示语
  isCode.value = false // 是否发送了验证码
  telAndEmailInfo.email = ''
  telAndEmailInfo.mobile_zone = '+86'
  telAndEmailInfo.mobile = ''
  telAndEmailInfo.code = ''
  telAndEmailInfo.verify_type = type
  getcode.verify_type = type
  Time.value = 0
}
// ********************************修改手机号和邮箱*****************************
// 是否获取了验证码
const isCode = ref(false)
// 倒计时
const Time = ref(0)
const Timefn = () => {
  Time.value = 60
  const t = setInterval(() => {
    // Btndisabled.value = true
    Time.value -= 1
    if (Time.value < 1) {
      clearInterval(t)
      // Btndisabled.value = false
      Time.value = 0
      clearInterval(t)
    }
  }, 1000)
}
const rulesOne = reactive<FormRules>({
  mobile: [{ required: true, message: t('login.mobileError'), trigger: 'blur', pattern: '[^ \x22]+' },
    { validator: myProfile.mobile_zone !== '+86' ? checkhandPhone : checkMobile, trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (!telAndEmailInfo.mobile_zone) {
          callback(new Error(t('myProfile.plecountry')))
        } else {
          callback()
        }
      },
      trigger: 'change'
    }
  ],
  email: { required: true, validator: checkEmail, trigger: 'blur' },
  code: { required: true, message: t('myProfile.Codelaceholder'), trigger: 'blur' }
})
// 防止修改新电话号码和邮箱
const isdisable = ref(false)
// 获取验证码
const getAuthenticationFn = () => {
  getAuthentication(getcode).then((res:any) => {
    if (res.code === 200) {
      Timefn()
      isCode.value = true
      telitem.value = true
      emailitem.value = true
      ElMessage.success(t('myProfile.Verificationcodesent'))
      isdisable.value = true
    } else {
      ElMessage.error(res.msg)
    }
  })
}
// 验证验证码
const saveLoading = ref(false)
const AuthenticationcodeFn = () => {
  if (!isCode.value) {
    proxy.$message.warning(t('myProfile.firstgetCode'))
    return
  }
  saveLoading.value = true
  Authenticationcode(telAndEmailInfo).then((res:any) => {
    if (res.code === 200) {
      saveLoading.value = false
      if (Type.value === 'tel') {
        myProfile.mobile = telAndEmailInfo.mobile
        myProfile.mobile_zone = telAndEmailInfo.mobile_zone
        if (localStorage.getItem('LANG') === 'en') {
          isEnglish.value = false
        } else {
          isEnglish.value = true
        }
        if (myProfile.mobile_zone === '+86') {
          isChinaTel.value = true
        } else {
          isChinaTel.value = false
        }
      } else {
        myProfile.email = telAndEmailInfo.email
      }
      ElMessage.success(res.msg)
      telitem.value = false
      emailitem.value = false
      isdisable.value = false
      TelAndEmailDialog.value = false
      close()
    } else {
      ElMessage.error(res.msg)
      telitem.value = false
      emailitem.value = false
      isdisable.value = false
      saveLoading.value = false
    }
  }).catch(() => {
    telitem.value = false
    emailitem.value = false
    saveLoading.value = false
  })
}
const TelAndEmailDialogRef = ref<InstanceType<typeof ElForm>>()
const TelAndEmailDialog = ref(false)
const Authentication = (type: any) => {
  telAndEmailInfo.code = ''
  // telAndEmailInfo.mobile = ''
  // telAndEmailInfo.email = ''
  telAndEmailInfo.verify_type = type
  getcode.verify_type = type
  if (Type.value === 'tel') {
    if (Number(type) === 1) {
      getcode.mobile = telAndEmailInfo.mobile
      getcode.mobile_zone = telAndEmailInfo.mobile_zone
    } else if (Number(type) === 2) {
      getcode.email = myProfile.email
      telAndEmailInfo.email = myProfile.email
      getAuthenticationFn()
    }
  } else if (Type.value === 'email') {
    if (Number(type) === 2) {
      getcode.email = telAndEmailInfo.email
    } else if (Number(type) === 1) {
      telAndEmailInfo.mobile = myProfile.mobile
      getcode.mobile_zone = myProfile.mobile_zone ? myProfile.mobile_zone : '+86'
      getcode.mobile = myProfile.mobile
      telAndEmailInfo.mobile = myProfile.mobile
      getAuthenticationFn()
    }
  }
}
const Type = ref('')
const telitem = ref(false)
const emailitem = ref(false)
const title = ref('')
const telAndEmailInfo = reactive({
  verify_type: '1',
  mobile: '',
  email: '',
  mobile_zone: '+86',
  code: ''
})
const getcode = reactive({
  verify_type: 1,
  mobile: '',
  mobile_zone: '',
  email: ''
})
const TypeList = ref({
  1: t('myProfile.telcomfirm'),
  2: t('myProfile.emailcomfirm')
  // 3: '人脸识别验证'
})
const ChangTelAndEmail = (type:any, num: string) => {
  Type.value = type
  TelAndEmailDialog.value = true
  if (type === 'tel') {
    title.value = t('myProfile.changeTel')
    getcode.mobile = num
    getcode.email = ''
  } else {
    title.value = t('myProfile.changeEmail')
    getcode.mobile = ''
    getcode.email = num
  }
}
// 提交
const submit = () => {
  TelAndEmailDialogRef.value.validate((valid, fields) => {
    if (valid) {
      AuthenticationcodeFn()
    }
  })
}
// 点击获取验证码
const getnewcode = (num:any) => {
  if (num) {
    if (Type.value === 'tel') {
      getcode.mobile = num
      if (telAndEmailInfo.verify_type === '1') {
        getcode.mobile_zone = telAndEmailInfo.mobile_zone
      }
      getAuthenticationFn()
    } else {
      getcode.email = num
      getAuthenticationFn()
    }
  }
}
// 取消单选
const cancleradio = (val:any) => {
  myProfile.type = val === myProfile.type ? '' : val
}
// *********************************************************************获取验证码相关操作 start***********************************************************
const mobileCodeDisabled = ref(false)
const companyCodeDisabled = ref(false)
const mobileCodeEnd = ref(60)
const companyCodeEnd = ref(60)
// 获取手机号验证码
const getCodeYzm = (type:any, mobile:any, zone:any) => {
  const data = {
    mobile_zone: zone,
    mobile,
    verify_type: 1
  }
  if (type === 1) {
    ruleFormRef.value?.clearValidate('mobile')
    getAuthentication(data).then((res:any) => {
      if (res.code === 200) {
        ElMessage.success(res.msg)
        disabledFn(mobileCodeDisabled, mobileCodeEnd)
      } else {
        ElMessage.error(res.result || res.msg)
      }
    })
  } else {
    ruleFormRef.value?.clearValidate('companyContactMobile')
    getAuthentication(data).then((res:any) => {
      if (res.code === 200) {
        ElMessage.success(res.msg)
        disabledFn(companyCodeDisabled, companyCodeEnd)
      } else {
        ElMessage.error(res.result || res.msg)
      }
    })
  }
}
// 禁用函数
const disabledFn = (disabled: any, CodeEnd: any) => {
  disabled.value = true
  var t = setInterval(() => {
    CodeEnd.value -= 1
    if (CodeEnd.value < 1) {
      clearInterval(t)
      disabled.value = false
      CodeEnd.value = 0
    }
  }, 1000)
}
// **********************************************************修改密码********************************************
const pwdDisabled = ref(true)
const ChangepwdFn = () => {
  pwdDisabled.value = false
  myProfile.password = ''
}
// *******************************************************上传资格证书文件****************************************************
const handleRemovequ = (item:any, index:number) => {
  // console.log(item)
  item.splice(index, 1)
}
// 上传资格证书
const handleQualificationSuccess: UploadProps['onSuccess'] = (obj:any, response: any) => {
  companyQualificationList.value[obj.index].isloading = false
  // 接口无数据是null，不是数组
  // console.log(response.data.path)
  if (!Array.isArray(myProfile.qualificationPhoto[obj.index])) {
    myProfile.qualificationPhoto[obj.index] = [response.data.path]
  } else {
    myProfile.qualificationPhoto[obj.index].push(response.data.path)
    // if (FromInfo.license[obj.index].length < 3) {
    //   for (let i = 0; i < RegisterInfo.talentQualification.length; i++) {
    //     if (RegisterInfo.talentQualification[i].professionalTitle === obj.data) {
    //       RegisterInfo.talentQualification[i].certification.push(response.result[0].path)
    //       break
    //     }
    //   }
    // } else {
    //   ElMessage.error(t('myProfile.licenseLength'))
    // }
  }
  if (myProfile.qualificationPhoto[obj.index].length === 1) {
    if (!myProfile.qualificationPhoto[obj.index].includes(obj.data)) {
      // console.log(myProfile.qualification)
      myProfile.qualification.push(obj.data)
    }
  }
  ruleFormRef.value?.validateField('qualification')
}
const handleQualificationError = (obj:any) => {
  companyQualificationList.value[obj.index].isloading = false
}
// 营业执照图片上传之前的钩子
const businessQualificationUpload: UploadProps['beforeUpload'] = (obj:any, rawFile:any) => {
  const imageType = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg']
  if (imageType.indexOf(rawFile.type) === -1) {
    ElMessage.error(t('myProfile.licenseType'))
    return false
  } else if (rawFile.size / 1024 / 1024 > 20) {
    ElMessage.error(t('myProfile.licenseSize'))
    return false
  }
  companyQualificationList.value[obj.index].isloading = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('myProfile.registerInfo')), 1)
            ]),
            _withDirectives((_openBlock(), _createBlock(_unref(ElForm), {
              ref_key: "ruleFormRef",
              ref: ruleFormRef,
              model: myProfile,
              rules: rules,
              "label-width": "120px",
              size: formSize.value,
              "status-icon": "",
              disabled: !isEdit.value,
              class: "myProfile-form",
              style: {"min-width":"900px","margin":"0 auto","max-width":"1400px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('myProfile.acountInfo')), 1)
                ]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('myProfile.username'),
                  class: "myProfile-form__start",
                  prop: "username"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: myProfile.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((myProfile.username) = $event)),
                      disabled: "",
                      maxlength: "50",
                      placeholder: _unref(t)('myProfile.account')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('myProfile.password'),
                  prop: "password"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_input, {
                        modelValue: myProfile.password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((myProfile.password) = $event)),
                        modelModifiers: { trim: true },
                        disabled: pwdDisabled.value,
                        type: "password",
                        "show-password": "",
                        placeholder: _unref(t)('myProfile.PLinput')+_unref(t)('myProfile.password')
                      }, null, 8, ["modelValue", "disabled", "placeholder"]),
                      (pwdDisabled.value)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            onClick: ChangepwdFn
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('setting.changePassword')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('myProfile.personmessage')), 1)
                ]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('myProfile.name'),
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: myProfile.name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((myProfile.name) = $event)),
                      maxlength: "100",
                      placeholder: _unref(t)('myProfile.validateName')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                (myProfile.mobile_zone === '+86')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: _unref(t)('myProfile.mobile'),
                      prop: "mobile"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_el_input, {
                            modelValue: myProfile.mobile,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((myProfile.mobile) = $event)),
                            formatter: (value) => value.replace(/\s+/g, ''),
                            clearable: "",
                            placeholder: _unref(t)('login.mobileError')
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: myProfile.mobile_zone,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((myProfile.mobile_zone) = $event)),
                                onChange: getMobilezone,
                                clearable: "",
                                placeholder: _unref(t)('common.pleaseSelect'),
                                filterable: "",
                                style: {"width":"70px"},
                                onVisibleChange: selectFocus,
                                class: "zoneSelect"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryCodeList.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: isFocus.value?(!isEnglish.value?item.label:item.labelen):item.zone_code,
                                      value: item.zone_code
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(!isEnglish.value?item.label:item.labelen), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "formatter", "placeholder"]),
                          (isEnglish.value)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                style: {"padding":"0","font-size":"10px","min-width":"30px"},
                                disabled: mobileCodeDisabled.value,
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (getCodeYzm(1,myProfile.mobile,myProfile.mobile_zone)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(mobileCodeDisabled.value? mobileCodeEnd.value :'验证码'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"]))
                            : _createCommentVNode("", true),
                          (isEnglish.value)
                            ? (_openBlock(), _createBlock(_component_el_input, {
                                key: 1,
                                style: {"width":"10%","min-width":"55px"},
                                modelValue: myProfile.mobileCode,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((myProfile.mobileCode) = $event))
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: _unref(t)('myProfile.mobile'),
                      prop: "mobileen"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_el_input, {
                            modelValue: myProfile.mobile,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((myProfile.mobile) = $event)),
                            formatter: (value) => value.replace(/\s+/g, ''),
                            clearable: "",
                            placeholder: _unref(t)('login.mobileError')
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: myProfile.mobile_zone,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((myProfile.mobile_zone) = $event)),
                                onChange: getMobilezone,
                                clearable: "",
                                placeholder: _unref(t)('common.pleaseSelect'),
                                filterable: "",
                                style: {"width":"70px"},
                                onVisibleChange: selectFocus,
                                class: "zoneSelect"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryCodeList.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: isFocus.value?(!isEnglish.value?item.label:item.labelen):item.zone_code,
                                      value: item.zone_code
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(!isEnglish.value?item.label:item.labelen), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "formatter", "placeholder"]),
                          (isEnglish.value)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                style: {"padding":"0","font-size":"10px","min-width":"30px"},
                                disabled: mobileCodeDisabled.value,
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (getCodeYzm(1,myProfile.mobile,myProfile.mobile_zone)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(mobileCodeDisabled.value? mobileCodeEnd.value :'验证码'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"]))
                            : _createCommentVNode("", true),
                          (isEnglish.value)
                            ? (_openBlock(), _createBlock(_component_el_input, {
                                key: 1,
                                style: {"width":"10%","min-width":"55px"},
                                modelValue: myProfile.mobileCode,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((myProfile.mobileCode) = $event))
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"])),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('myProfile.email'),
                  prop: "email"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_el_input, {
                        modelValue: myProfile.email,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((myProfile.email) = $event)),
                        placeholder: _unref(t)('myProfile.plemail')
                      }, null, 8, ["modelValue", "placeholder"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('myProfile.WeChatOrQQ'),
                  prop: isEnglish.value?'wechat':'',
                  style: {"height":"32px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: myProfile.wechat,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((myProfile.wechat) = $event)),
                      placeholder: _unref(t)('myProfile.wechatqq')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label", "prop"]),
                (myProfile.identity==='PERSONAL'&&(isEnglish.value&&isChinaTel.value))
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: _unref(t)('myProfile.IDnum'),
                      prop: "id_no",
                      style: {"height":"32px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: myProfile.id_no,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((myProfile.id_no) = $event)),
                          placeholder: _unref(t)('myProfile.idcard')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (myProfile.identity==='PERSONAL'&&((!isEnglish.value)||(!isChinaTel.value)))
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      label: _unref(t)('myProfile.IDnum'),
                      style: {"height":"32px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: myProfile.id_no,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((myProfile.id_no) = $event)),
                          placeholder: _unref(t)('myProfile.idcard')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (myProfile.identity==='PERSONAL'&&(isEnglish.value&&isChinaTel.value))
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 4,
                      label: _unref(t)('myProfile.identity'),
                      prop: "front"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_el_tooltip, {
                            content: _unref(t)('myProfile.supportsize'),
                            placement: "bottom",
                            effect: "light"
                          }, {
                            default: _withCtx(() => [
                              (isEnglish.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("div", null, [
                                      (myProfile.front)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            (myProfile.front.indexOf('.pdf') === -1)
                                              ? (_openBlock(), _createBlock(_component_el_image, {
                                                  key: 0,
                                                  src: _unref(fileUrl)+myProfile.front,
                                                  class: "avatar",
                                                  "zoom-rate": 1.2,
                                                  "preview-src-list": [_unref(fileUrl) + myProfile.front],
                                                  "initial-index": 4,
                                                  fit: "cover",
                                                  style: {"height":"50px"}
                                                }, null, 8, ["src", "zoom-rate", "preview-src-list"]))
                                              : (_openBlock(), _createElementBlock("div", {
                                                  key: 1,
                                                  class: "businessLicense-block__pdf",
                                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (onOpenPDFFile(myProfile.front)))
                                                }, _hoisted_16)),
                                            _createElementVNode("img", {
                                              src: _imports_1,
                                              class: "businessLicense-delete",
                                              onClick: _cache[16] || (_cache[16] = ($event: any) => (myProfile.front = '')),
                                              alt: ""
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!myProfile.front)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                                            key: 1,
                                            class: "avatar-uploader",
                                            action: "/api/upload",
                                            "show-file-list": false,
                                            limit: 1,
                                            disabled: !isEdit.value,
                                            "http-request": request,
                                            "on-success": handlefrontSuccess,
                                            "on-error": handlefrontError,
                                            "before-upload": beforefrontUpload,
                                            accept: ".jpg, .jpeg, .png, .pdf"
                                          }, {
                                            default: _withCtx(() => [
                                              (!myProfile.front && isEdit.value)
                                                ? (_openBlock(), _createBlock(_component_el_button, {
                                                    key: 0,
                                                    type: "primary"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_unref(t)('common.upload')), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])), [
                                            [_directive_loading, frontLoading.value]
                                          ])
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('myProfile.front')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["content"]),
                          _createVNode(_component_el_tooltip, {
                            content: _unref(t)('myProfile.supportsize'),
                            placement: "bottom",
                            effect: "light"
                          }, {
                            default: _withCtx(() => [
                              (isEnglish.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("div", null, [
                                      (myProfile.opposite)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            (myProfile.opposite.indexOf('.pdf') === -1)
                                              ? (_openBlock(), _createBlock(_component_el_image, {
                                                  key: 0,
                                                  src: _unref(fileUrl)+myProfile.opposite,
                                                  class: "avatar",
                                                  "zoom-rate": 1.2,
                                                  "preview-src-list": [_unref(fileUrl) + myProfile.opposite],
                                                  "initial-index": 4,
                                                  fit: "cover",
                                                  style: {"height":"50px"}
                                                }, null, 8, ["src", "zoom-rate", "preview-src-list"]))
                                              : (_openBlock(), _createElementBlock("div", {
                                                  key: 1,
                                                  class: "businessLicense-block__pdf",
                                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (onOpenPDFFile(myProfile.opposite)))
                                                }, _hoisted_21)),
                                            _createElementVNode("img", {
                                              src: _imports_1,
                                              class: "businessLicense-delete",
                                              onClick: _cache[18] || (_cache[18] = ($event: any) => (myProfile.opposite = '')),
                                              alt: ""
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!myProfile.opposite)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                                            key: 1,
                                            class: "avatar-uploader",
                                            action: "/api/upload",
                                            "show-file-list": false,
                                            limit: 1,
                                            disabled: !isEdit.value,
                                            "http-request": request,
                                            "on-success": handleoppositeSuccess,
                                            "on-error": handleoppositeError,
                                            "before-upload": beforeoppositeUpload,
                                            accept: ".jpg, .jpeg, .png, .pdf"
                                          }, {
                                            default: _withCtx(() => [
                                              (!myProfile.opposite && isEdit.value)
                                                ? (_openBlock(), _createBlock(_component_el_button, {
                                                    key: 0,
                                                    type: "primary"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_unref(t)('common.upload')), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])), [
                                            [_directive_loading, oppositeLoading.value]
                                          ])
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('myProfile.opposite')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["content"]),
                          _createVNode(_component_el_tooltip, {
                            content: _unref(t)('myProfile.supportsize'),
                            placement: "bottom",
                            effect: "light"
                          }, {
                            default: _withCtx(() => [
                              (!isEnglish.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _createElementVNode("div", null, [
                                      (myProfile.passport)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                            (myProfile.passport.indexOf('.pdf') === -1)
                                              ? (_openBlock(), _createBlock(_component_el_image, {
                                                  key: 0,
                                                  src: _unref(fileUrl)+myProfile.passport,
                                                  class: "avatar",
                                                  "zoom-rate": 1.2,
                                                  "preview-src-list": [_unref(fileUrl) + myProfile.passport],
                                                  "initial-index": 4,
                                                  fit: "cover",
                                                  style: {"height":"50px"}
                                                }, null, 8, ["src", "zoom-rate", "preview-src-list"]))
                                              : (_openBlock(), _createElementBlock("div", {
                                                  key: 1,
                                                  class: "businessLicense-block__pdf",
                                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (onOpenPDFFile(myProfile.passport)))
                                                }, _hoisted_26)),
                                            _createElementVNode("img", {
                                              src: _imports_1,
                                              class: "businessLicense-delete",
                                              onClick: _cache[20] || (_cache[20] = ($event: any) => (myProfile.passport = '')),
                                              alt: ""
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!myProfile.passport)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                                            key: 1,
                                            class: "avatar-uploader",
                                            action: "/api/upload",
                                            "show-file-list": false,
                                            limit: 1,
                                            disabled: !isEdit.value,
                                            "http-request": request,
                                            "on-success": handlepassportSuccess,
                                            "on-error": handlepassportError,
                                            "before-upload": beforepassportUpload,
                                            accept: ".jpg, .jpeg, .png, .pdf"
                                          }, {
                                            default: _withCtx(() => [
                                              (!myProfile.passport && isEdit.value)
                                                ? (_openBlock(), _createBlock(_component_el_button, {
                                                    key: 0,
                                                    type: "primary"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_unref(t)('common.upload')), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])), [
                                            [_directive_loading, passportLoading.value]
                                          ])
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)('myProfile.passportimg')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (myProfile.identity==='PERSONAL'&&((!isEnglish.value)||(!isChinaTel.value)))
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      label: _unref(t)('myProfile.identity')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_el_tooltip, {
                            content: _unref(t)('myProfile.supportsize'),
                            placement: "bottom",
                            effect: "light"
                          }, {
                            default: _withCtx(() => [
                              (isEnglish.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _createElementVNode("div", null, [
                                      (myProfile.front)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                            (myProfile.front.indexOf('.pdf') === -1)
                                              ? (_openBlock(), _createBlock(_component_el_image, {
                                                  key: 0,
                                                  src: _unref(fileUrl)+myProfile.front,
                                                  class: "avatar",
                                                  "zoom-rate": 1.2,
                                                  "preview-src-list": [_unref(fileUrl) + myProfile.front],
                                                  "initial-index": 4,
                                                  fit: "cover",
                                                  style: {"height":"50px"}
                                                }, null, 8, ["src", "zoom-rate", "preview-src-list"]))
                                              : (_openBlock(), _createElementBlock("div", {
                                                  key: 1,
                                                  class: "businessLicense-block__pdf",
                                                  onClick: _cache[21] || (_cache[21] = ($event: any) => (onOpenPDFFile(myProfile.front)))
                                                }, _hoisted_32)),
                                            _createElementVNode("img", {
                                              src: _imports_1,
                                              class: "businessLicense-delete",
                                              onClick: _cache[22] || (_cache[22] = ($event: any) => (myProfile.front = '')),
                                              alt: ""
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!myProfile.front)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                                            key: 1,
                                            class: "avatar-uploader",
                                            action: "/api/upload",
                                            "show-file-list": false,
                                            limit: 1,
                                            disabled: !isEdit.value,
                                            "http-request": request,
                                            "on-success": handlefrontSuccess,
                                            "on-error": handlefrontError,
                                            "before-upload": beforefrontUpload,
                                            accept: ".jpg, .jpeg, .png, .pdf"
                                          }, {
                                            default: _withCtx(() => [
                                              (!myProfile.front && isEdit.value)
                                                ? (_openBlock(), _createBlock(_component_el_button, {
                                                    key: 0,
                                                    type: "primary"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_unref(t)('common.upload')), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])), [
                                            [_directive_loading, frontLoading.value]
                                          ])
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(t)('myProfile.front')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["content"]),
                          _createVNode(_component_el_tooltip, {
                            content: _unref(t)('myProfile.supportsize'),
                            placement: "bottom",
                            effect: "light"
                          }, {
                            default: _withCtx(() => [
                              (isEnglish.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("div", null, [
                                      (myProfile.opposite)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                            (myProfile.opposite.indexOf('.pdf') === -1)
                                              ? (_openBlock(), _createBlock(_component_el_image, {
                                                  key: 0,
                                                  src: _unref(fileUrl)+myProfile.opposite,
                                                  class: "avatar",
                                                  "zoom-rate": 1.2,
                                                  "preview-src-list": [_unref(fileUrl) + myProfile.opposite],
                                                  "initial-index": 4,
                                                  fit: "cover",
                                                  style: {"height":"50px"}
                                                }, null, 8, ["src", "zoom-rate", "preview-src-list"]))
                                              : (_openBlock(), _createElementBlock("div", {
                                                  key: 1,
                                                  class: "businessLicense-block__pdf",
                                                  onClick: _cache[23] || (_cache[23] = ($event: any) => (onOpenPDFFile(myProfile.opposite)))
                                                }, _hoisted_37)),
                                            _createElementVNode("img", {
                                              src: _imports_1,
                                              class: "businessLicense-delete",
                                              onClick: _cache[24] || (_cache[24] = ($event: any) => (myProfile.opposite = '')),
                                              alt: ""
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!myProfile.opposite)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                                            key: 1,
                                            class: "avatar-uploader",
                                            action: "/api/upload",
                                            "show-file-list": false,
                                            limit: 1,
                                            disabled: !isEdit.value,
                                            "http-request": request,
                                            "on-success": handleoppositeSuccess,
                                            "on-error": handleoppositeError,
                                            "before-upload": beforeoppositeUpload,
                                            accept: ".jpg, .jpeg, .png, .pdf"
                                          }, {
                                            default: _withCtx(() => [
                                              (!myProfile.opposite && isEdit.value)
                                                ? (_openBlock(), _createBlock(_component_el_button, {
                                                    key: 0,
                                                    type: "primary"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_unref(t)('common.upload')), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])), [
                                            [_directive_loading, oppositeLoading.value]
                                          ])
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(t)('myProfile.opposite')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["content"]),
                          _createVNode(_component_el_tooltip, {
                            content: _unref(t)('myProfile.supportsize'),
                            placement: "bottom",
                            effect: "light"
                          }, {
                            default: _withCtx(() => [
                              (!isEnglish.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _createElementVNode("div", null, [
                                      (myProfile.passport)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                            (myProfile.passport.indexOf('.pdf') === -1)
                                              ? (_openBlock(), _createBlock(_component_el_image, {
                                                  key: 0,
                                                  src: _unref(fileUrl)+myProfile.passport,
                                                  class: "avatar",
                                                  "zoom-rate": 1.2,
                                                  "preview-src-list": [_unref(fileUrl) + myProfile.passport],
                                                  "initial-index": 4,
                                                  fit: "cover",
                                                  style: {"height":"50px"}
                                                }, null, 8, ["src", "zoom-rate", "preview-src-list"]))
                                              : (_openBlock(), _createElementBlock("div", {
                                                  key: 1,
                                                  class: "businessLicense-block__pdf",
                                                  onClick: _cache[25] || (_cache[25] = ($event: any) => (onOpenPDFFile(myProfile.passport)))
                                                }, _hoisted_42)),
                                            _createElementVNode("img", {
                                              src: _imports_1,
                                              class: "businessLicense-delete",
                                              onClick: _cache[26] || (_cache[26] = ($event: any) => (myProfile.passport = '')),
                                              alt: ""
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!myProfile.passport)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                                            key: 1,
                                            class: "avatar-uploader",
                                            action: "/api/upload",
                                            "show-file-list": false,
                                            limit: 1,
                                            disabled: !isEdit.value,
                                            "http-request": request,
                                            "on-success": handlepassportSuccess,
                                            "on-error": handlepassportError,
                                            "before-upload": beforepassportUpload,
                                            accept: ".jpg, .jpeg, .png, .pdf"
                                          }, {
                                            default: _withCtx(() => [
                                              (!myProfile.passport && isEdit.value)
                                                ? (_openBlock(), _createBlock(_component_el_button, {
                                                    key: 0,
                                                    type: "primary"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_unref(t)('common.upload')), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])), [
                                            [_directive_loading, passportLoading.value]
                                          ])
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(t)('myProfile.passportimg')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (myProfile.identity==='PERSONAL')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 6,
                      label: _unref(t)('myProfile.channelType'),
                      prop: "identity_type",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: myProfile.identity_type,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((myProfile.identity_type) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(PerstatusList.value, (item, key, index) => {
                              return (_openBlock(), _createBlock(_component_el_radio, {
                                key: index,
                                label: key
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (myProfile.identity!=='PERSONAL')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('myProfile.compouyinfo')), 1)
                      ]),
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('myProfile.customerIds'),
                        prop: "identity",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: myProfile.identity,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((myProfile.identity) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusList.value, (item, key, index) => {
                                return (_openBlock(), _createBlock(_component_el_radio, {
                                  key: index,
                                  label: key
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item) + " ", 1),
                                    (myProfile.identity==='IDENTITY_AGENCY'&&key==='IDENTITY_AGENCY')
                                      ? (_openBlock(), _createBlock(_component_el_select, {
                                          key: 0,
                                          modelValue: myProfile.identity_type,
                                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((myProfile.identity_type) = $event)),
                                          style: {"width":"150px"}
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusListChannel.value, (item, key, index) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: index,
                                                label: item,
                                                value: key
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('myProfile.companyName'),
                        prop: "company",
                        class: "dropdown-block"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: myProfile.company,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((myProfile.company) = $event)),
                            placeholder: _unref(t)('myProfile.searchCompany'),
                            clearable: "",
                            onInput: getComponyDetail
                          }, null, 8, ["modelValue", "placeholder"]),
                          _createVNode(_component_el_dropdown, {
                            ref_key: "dropdown1",
                            ref: dropdown1,
                            trigger: "contextmenu"
                          }, {
                            dropdown: _withCtx(() => [
                              _createVNode(_component_el_dropdown_menu, { style: {"width":"300px","height":"300px","overflow":"auto"} }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(componyDataList.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: index,
                                      onClick: ($event: any) => (checkCompony(item))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.Name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _hoisted_47
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      (isEnglish.value&&isChinaTel.value)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: _unref(t)('myProfile.compounenyNum'),
                            prop: "company_usci"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: myProfile.company_usci,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((myProfile.company_usci) = $event)),
                                placeholder: _unref(t)('myProfile.unifiedsocial'),
                                onKeyup: _cache[32] || (_cache[32] = ($event: any) => (myProfile.companyUsci=myProfile.companyUsci.replace(/[\W]/g,'')))
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      ((!isEnglish.value)||(!isChinaTel.value))
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: _unref(t)('myProfile.compounenyNum')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: myProfile.company_usci,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((myProfile.company_usci) = $event)),
                                placeholder: _unref(t)('myProfile.unifiedsocial'),
                                onKeyup: _cache[34] || (_cache[34] = ($event: any) => (myProfile.companyUsci=myProfile.companyUsci.replace(/[\W]/g,'')))
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      (isEnglish.value&&isChinaTel.value)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            label: _unref(t)('myProfile.businessLicense'),
                            prop: "license",
                            ref_key: "uploadElement",
                            ref: uploadElement
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tooltip, {
                                content: _unref(t)('myProfile.uploadFormat'),
                                placement: "bottom",
                                effect: "light"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_48, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myProfile.license, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "businessLicense-block-section"
                                        }, [
                                          (item.indexOf('.pdf') === -1)
                                            ? (_openBlock(), _createBlock(_component_el_image, {
                                                key: 0,
                                                class: "businessLicense-block__img cover__img",
                                                src: _unref(fileUrl) + item,
                                                "zoom-rate": 1.2,
                                                "preview-src-list": [_unref(fileUrl) + item],
                                                "initial-index": 4,
                                                fit: "cover"
                                              }, null, 8, ["src", "zoom-rate", "preview-src-list"]))
                                            : (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: "businessLicense-block__pdf",
                                                onClick: ($event: any) => (onOpenPDFFile(item))
                                              }, _hoisted_51, 8, _hoisted_49)),
                                          (item.indexOf('.pdf') === -1)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 2,
                                                src: _imports_1,
                                                class: "businessLicense-delete",
                                                onClick: ($event: any) => (handleRemove(index)),
                                                alt: ""
                                              }, null, 8, _hoisted_52))
                                            : (_openBlock(), _createElementBlock("img", {
                                                key: 3,
                                                src: _imports_1,
                                                class: "businessLicense-delete-pdf",
                                                onClick: ($event: any) => (handleRemove(index)),
                                                alt: ""
                                              }, null, 8, _hoisted_53))
                                        ]))
                                      }), 128)),
                                      (myProfile.license.length < 1)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                                            key: 0,
                                            class: "upload-block",
                                            action: "/api/upload",
                                            "show-file-list": false,
                                            "http-request": request,
                                            "on-success": handleLicenseSuccess,
                                            "on-error": handleLinceseError,
                                            "before-upload": businessLicenseUpload,
                                            drag: "",
                                            accept: ".jpg, .jpeg, .png, .pdf"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, {
                                                class: "el-icon--upload",
                                                style: {"font-size":"22px"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(UploadFilled))
                                                ]),
                                                _: 1
                                              }),
                                              _createElementVNode("div", _hoisted_54, _toDisplayString(_unref(t)('myProfile.uploadFile')), 1)
                                            ]),
                                            _: 1
                                          })), [
                                            [_directive_loading, isShowBusinessLoading.value]
                                          ])
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(t)('myProfile.uploadFormat')), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["content"])
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      ((!isEnglish.value)||(!isChinaTel.value))
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            label: _unref(t)('myProfile.businessLicense'),
                            ref_key: "uploadElement",
                            ref: uploadElement
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tooltip, {
                                content: _unref(t)('myProfile.uploadFormat'),
                                placement: "bottom",
                                effect: "light"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_56, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myProfile.license, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "businessLicense-block-section"
                                        }, [
                                          (item.indexOf('.pdf') === -1)
                                            ? (_openBlock(), _createBlock(_component_el_image, {
                                                key: 0,
                                                class: "businessLicense-block__img cover__img",
                                                src: _unref(fileUrl) + item,
                                                "zoom-rate": 1.2,
                                                "preview-src-list": [_unref(fileUrl) + item],
                                                "initial-index": 4,
                                                fit: "cover"
                                              }, null, 8, ["src", "zoom-rate", "preview-src-list"]))
                                            : (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: "businessLicense-block__pdf",
                                                onClick: ($event: any) => (onOpenPDFFile(item))
                                              }, _hoisted_59, 8, _hoisted_57)),
                                          (item.indexOf('.pdf') === -1)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 2,
                                                src: _imports_1,
                                                class: "businessLicense-delete",
                                                onClick: ($event: any) => (handleRemove(index)),
                                                alt: ""
                                              }, null, 8, _hoisted_60))
                                            : (_openBlock(), _createElementBlock("img", {
                                                key: 3,
                                                src: _imports_1,
                                                class: "businessLicense-delete-pdf",
                                                onClick: ($event: any) => (handleRemove(index)),
                                                alt: ""
                                              }, null, 8, _hoisted_61))
                                        ]))
                                      }), 128)),
                                      (myProfile.license.length < 1)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                                            key: 0,
                                            class: "upload-block",
                                            action: "/api/upload",
                                            "show-file-list": false,
                                            "http-request": request,
                                            "on-success": handleLicenseSuccess,
                                            "on-error": handleLinceseError,
                                            "before-upload": businessLicenseUpload,
                                            drag: "",
                                            accept: ".jpg, .jpeg, .png, .pdf"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, {
                                                class: "el-icon--upload",
                                                style: {"font-size":"22px"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(UploadFilled))
                                                ]),
                                                _: 1
                                              }),
                                              _createElementVNode("div", _hoisted_62, _toDisplayString(_unref(t)('myProfile.uploadFile')), 1)
                                            ]),
                                            _: 1
                                          })), [
                                            [_directive_loading, isShowBusinessLoading.value]
                                          ])
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_63, _toDisplayString(_unref(t)('myProfile.uploadFormat')), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["content"])
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      (myProfile.country_id !== 'CN')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 4,
                            label: _unref(t)('myProfile.selectCountry'),
                            prop: "country_id"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: myProfile.country_id,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((myProfile.country_id) = $event)),
                                filterable: "",
                                clearable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contryList.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      style: {"width":"400px"},
                                      key: item.id,
                                      label: isEnglish.value? item.remarks:item.name,
                                      value: item.code
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      (myProfile.country_id === 'CN')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 5,
                            label: _unref(t)('myProfile.selectProvinceCityRegion'),
                            prop: "allList"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_64, [
                                _createVNode(_component_el_select, {
                                  modelValue: myProfile.country_id,
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((myProfile.country_id) = $event)),
                                  filterable: "",
                                  clearable: "",
                                  style: {"min-width":"80px","width":"15%"},
                                  class: "special-select",
                                  onChange: nationalityChange
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contryList.value, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: isEnglish.value? item.remarks:item.name,
                                        value: item.code
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _createVNode(_component_el_cascader, {
                                  props: props,
                                  style: {"width":"95%"},
                                  ref_key: "treelistref",
                                  ref: treelistref,
                                  onChange: onChangeCity,
                                  modelValue: myProfile.allList,
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((myProfile.allList) = $event))
                                }, null, 8, ["props", "modelValue"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('myProfile.addressDetail'),
                        prop: "address"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: myProfile.address,
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((myProfile.address) = $event)),
                            placeholder: _unref(t)('myProfile.address')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('myProfile.companywebsite'),
                        prop: "website"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: myProfile.website,
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((myProfile.website) = $event)),
                            placeholder: _unref(t)('myProfile.website')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('myProfile.companyPhone'),
                        prop: "telephone"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: myProfile.telephone,
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((myProfile.telephone) = $event)),
                            placeholder: _unref(t)('myProfile.plecompanyphone')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      (isEnglish.value)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 6,
                            label: _unref(t)('myProfile.componyhumantel'),
                            prop: "company_contact_mobile"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_65, [
                                _createVNode(_component_el_input, {
                                  modelValue: myProfile.company_contact_mobile,
                                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((myProfile.company_contact_mobile) = $event)),
                                  formatter: (value) => value.replace(/\s+/g, ''),
                                  clearable: "",
                                  placeholder: _unref(t)('login.mobileError')
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: myProfile.company_contact_mobile_zone,
                                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((myProfile.company_contact_mobile_zone) = $event)),
                                      clearable: "",
                                      placeholder: _unref(t)('common.pleaseSelect'),
                                      filterable: "",
                                      style: {"width":"70px"},
                                      onVisibleChange: selectFocus,
                                      class: "zoneSelect"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryCodeList.value, (item, index) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: index,
                                            label: isFocus.value?(!isEnglish.value?item.label:item.labelen):item.zone_code,
                                            value: item.zone_code
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(!isEnglish.value?item.label:item.labelen), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "placeholder"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "formatter", "placeholder"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('myProfile.postcode'),
                        prop: "company_email"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: myProfile.company_email,
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((myProfile.company_email) = $event)),
                            maxlength: "50",
                            placeholder: _unref(t)('myProfile.zipcode')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      (myProfile.identity==='IDENTITY_AGENCY')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 7,
                            label: _unref(t)('myProfile.companysize'),
                            prop: "qualification",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_checkbox_group, {
                                modelValue: myProfile.qualification,
                                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((myProfile.qualification) = $event)),
                                style: {"text-align":"left"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyQualificationList.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                                      key: index,
                                      label: item.dicKey,
                                      style: {"width":"22%","margin-bottom":"20px"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_66, [
                                          _createElementVNode("span", null, _toDisplayString(item.dicValue), 1),
                                          (item.dicKey==='other'||item.dicKey==='Other')
                                            ? (_openBlock(), _createBlock(_component_el_input, {
                                                key: 0,
                                                modelValue: myProfile.qualification_others,
                                                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((myProfile.qualification_others) = $event)),
                                                placeholder: _unref(t)('common.pleaseEnter'),
                                                style: {"width":"250px","margin-left":"5px","border":"none","margin-right":"30px"},
                                                class: "sourceinput erro_disable",
                                                onInput: ($event: any) => (getotherItem(item.dicKey))
                                              }, null, 8, ["modelValue", "placeholder", "onInput"]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myProfile.qualificationPhoto[index], (itemin, i) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: i,
                                                class: "businessLicense-block-section"
                                              }, [
                                                (itemin&&itemin.indexOf('.pdf') === -1)
                                                  ? (_openBlock(), _createBlock(_component_el_image, {
                                                      key: 0,
                                                      class: "businessLicense-block__img cover__img",
                                                      src: _unref(fileUrl) + itemin,
                                                      "zoom-rate": 1.2,
                                                      "preview-src-list": [_unref(fileUrl) + itemin],
                                                      "initial-index": 4,
                                                      fit: "cover"
                                                    }, null, 8, ["src", "zoom-rate", "preview-src-list"]))
                                                  : _createCommentVNode("", true),
                                                (itemin&&itemin.indexOf('.pdf') !== -1)
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 1,
                                                      class: "businessLicense-block__pdf",
                                                      onClick: ($event: any) => (onOpenPDFFile(item))
                                                    }, _hoisted_69, 8, _hoisted_67))
                                                  : _createCommentVNode("", true),
                                                itemin
                                                  ? (_openBlock(), _createElementBlock("img", {
                                                      key: 2,
                                                      src: _imports_1,
                                                      class: "businessLicense-delete",
                                                      onClick: ($event: any) => (handleRemovequ(myProfile.qualificationPhoto[index],i)),
                                                      alt: ""
                                                    }, null, 8, _hoisted_70))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128)),
                                            (myProfile.qualificationPhoto[index]&&myProfile.qualificationPhoto[index].length<1)
                                              ? _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                                                  key: 0,
                                                  "show-file-list": false,
                                                  "http-request": request,
                                                  accept: ".jpg, .jpeg, .png, .gif, .pdf",
                                                  "on-success": handleQualificationSuccess.bind(null,{index,data:item.dicKey}),
                                                  "on-error": handleQualificationError.bind(null,{index}),
                                                  "before-upload": businessQualificationUpload.bind(null,{index})
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_tooltip, {
                                                      content: _unref(t)('myProfile.uploadFormat'),
                                                      placement: "bottom",
                                                      effect: "light"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_button, { icon: _unref(Plus) }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_unref(t)('myProfile.upload')), 1)
                                                          ]),
                                                          _: 1
                                                        }, 8, ["icon"])
                                                      ]),
                                                      _: 1
                                                    }, 8, ["content"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["on-success", "on-error", "before-upload"])), [
                                                  [_directive_loading, item.isloading]
                                                ])
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('myProfile.companyintro'),
                        prop: "intro",
                        class: "myProfile-form__start",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: myProfile.intro,
                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((myProfile.intro) = $event)),
                            "show-word-limit": "",
                            maxlength: !isEnglish.value?'10000':'500',
                            type: "textarea",
                            style: {"width":"98%"},
                            placeholder: _unref(t)('myProfile.inputcompanyintro')
                          }, null, 8, ["modelValue", "maxlength", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["model", "rules", "size", "disabled"])), [
              [_directive_loading, FormLoading.value]
            ]),
            _createElementVNode("div", _hoisted_71, [
              (isEdit.value)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: _cache[47] || (_cache[47] = ($event: any) => (submitForm(ruleFormRef.value)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('common.Confirm')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: TelAndEmailDialog.value,
      "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((TelAndEmailDialog).value = $event)),
      title: title.value,
      width: "700px",
      onClose: close
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_85, [
          _createVNode(_component_el_button, {
            onClick: _cache[73] || (_cache[73] = ($event: any) => (TelAndEmailDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.Cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[74] || (_cache[74] = ($event: any) => (submit())),
            loading: saveLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.Confirm')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), {
          model: telAndEmailInfo,
          rules: rulesOne,
          "label-width": "180px",
          inline: false,
          ref_key: "TelAndEmailDialogRef",
          ref: TelAndEmailDialogRef,
          class: "changcss"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('myProfile.PLcomfirmWay'),
              prop: "verify_type",
              style: {"display":"flex","align-items":"center","line-height":"20px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: telAndEmailInfo.verify_type,
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((telAndEmailInfo.verify_type) = $event)),
                  style: {"width":"400px"},
                  onChange: _cache[49] || (_cache[49] = ($event: any) => (changeWay(telAndEmailInfo.verify_type)))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(TypeList.value, (key, obj, i) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        key: i,
                        label: obj
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(key), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (Number(telAndEmailInfo.verify_type)===1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  (Type.value === 'tel')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: _unref(t)('myProfile.newTel'),
                        prop: "mobile",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: telAndEmailInfo.mobile,
                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((telAndEmailInfo.mobile) = $event)),
                            placeholder: _ctx.$t('register.mobilePlaceholder'),
                            class: "form_input"
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: telAndEmailInfo.mobile_zone,
                                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((telAndEmailInfo.mobile_zone) = $event)),
                                placeholder: _unref(t)('common.pleaseSelect'),
                                filterable: "",
                                style: {"width":"100px"},
                                onVisibleChange: selectFocus
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryCodeList.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: isFocus.value?(!isEnglish.value?item.label:item.labelen):item.zone_code,
                                      value: item.zone_code
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (Type.value !== 'tel')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: _unref(t)('myProfile.mobiletel'),
                        prop: "oldmobile"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: myProfile.oldmobile,
                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((myProfile.oldmobile) = $event)),
                            class: "form_input",
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (telitem.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_73, _toDisplayString(_unref(t)('myProfile.hasPhoneCode')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('myProfile.telCode'),
                    prop: "code",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      (Type.value !== 'tel')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                            _createVNode(_component_el_input, {
                              modelValue: telAndEmailInfo.code,
                              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((telAndEmailInfo.code) = $event)),
                              class: "form_input",
                              width: "100%"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[54] || (_cache[54] = ($event: any) => (Authentication(telAndEmailInfo.verify_type)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('myProfile.getCode')), 1),
                                (Time.value!==0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_75, "(" + _toDisplayString(Time.value) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (Type.value === 'tel')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                            _createVNode(_component_el_input, {
                              modelValue: telAndEmailInfo.code,
                              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((telAndEmailInfo.code) = $event)),
                              class: "form_input",
                              width: "100%"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[56] || (_cache[56] = ($event: any) => (getnewcode(telAndEmailInfo.mobile)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('myProfile.getCode')), 1),
                                (Time.value!==0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_77, "(" + _toDisplayString(Time.value) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  (Type.value === 'email')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 3,
                        label: _unref(t)('myProfile.newEmail'),
                        prop: "email",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: telAndEmailInfo.email,
                            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((telAndEmailInfo.email) = $event)),
                            class: "form_input"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (Type.value === 'tel'&&Number(telAndEmailInfo.verify_type)!==1)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 4,
                        label: _unref(t)('myProfile.newTel'),
                        prop: "mobile",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: telAndEmailInfo.mobile,
                            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((telAndEmailInfo.mobile) = $event)),
                            placeholder: _ctx.$t('register.mobilePlaceholder'),
                            class: "form_input",
                            clearable: ""
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: telAndEmailInfo.mobile_zone,
                                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((telAndEmailInfo.mobile_zone) = $event)),
                                clearable: "",
                                placeholder: _unref(t)('common.pleaseSelect'),
                                filterable: "",
                                style: {"width":"100px"},
                                onVisibleChange: selectFocus
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryCodeList.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: isFocus.value?(!isEnglish.value?item.label:item.labelen):item.zone_code,
                                      value: item.zone_code
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (Number(telAndEmailInfo.verify_type)===2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                  (Type.value === 'email')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: _unref(t)('myProfile.newEmail'),
                        prop: "email",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: telAndEmailInfo.email,
                            "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((telAndEmailInfo.email) = $event)),
                            class: "form_input",
                            disabled: isdisable.value
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (Type.value !== 'email')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: _unref(t)('myProfile.emailbox'),
                        prop: "oldemail"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: myProfile.oldemail,
                            "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((myProfile.oldemail) = $event)),
                            class: "form_input",
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (emailitem.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_79, _toDisplayString(_unref(t)('myProfile.hasEmailCode')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('myProfile.emailcode'),
                    prop: "code",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      (Type.value !== 'email')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                            _createVNode(_component_el_input, {
                              modelValue: telAndEmailInfo.code,
                              "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((telAndEmailInfo.code) = $event)),
                              class: "form_input",
                              width: "100%"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[63] || (_cache[63] = ($event: any) => (Authentication(telAndEmailInfo.verify_type)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('login.smsGet')), 1),
                                (Time.value!==0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_81, "(" + _toDisplayString(Time.value) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (Type.value === 'email')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                            _createVNode(_component_el_input, {
                              modelValue: telAndEmailInfo.code,
                              "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((telAndEmailInfo.code) = $event)),
                              class: "form_input",
                              width: "100%"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[65] || (_cache[65] = ($event: any) => (getnewcode(telAndEmailInfo.email)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('myProfile.getCode')), 1),
                                (Time.value!==0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_83, "(" + _toDisplayString(Time.value) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  (Type.value === 'email'&&Number(telAndEmailInfo.verify_type)!==2)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 3,
                        label: _unref(t)('myProfile.newEmail'),
                        prop: "email",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: telAndEmailInfo.email,
                            "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((telAndEmailInfo.email) = $event)),
                            class: "form_input"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (Type.value === 'tel')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 4,
                        label: _unref(t)('myProfile.newTel'),
                        prop: "mobile",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: telAndEmailInfo.mobile,
                            "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((telAndEmailInfo.mobile) = $event)),
                            placeholder: _ctx.$t('register.mobilePlaceholder'),
                            class: "form_input",
                            clearable: ""
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: telAndEmailInfo.mobile_zone,
                                "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((telAndEmailInfo.mobile_zone) = $event)),
                                clearable: "",
                                placeholder: _unref(t)('common.pleaseSelect'),
                                filterable: "",
                                style: {"width":"100px"},
                                onVisibleChange: selectFocus
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryCodeList.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: isFocus.value?(!isEnglish.value?item.label:item.labelen):item.zone_code,
                                      value: item.zone_code
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (Number(telAndEmailInfo.verify_type)===3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('myProfile.Scancodeverification'),
                    prop: "code",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: telAndEmailInfo.code,
                        "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((telAndEmailInfo.code) = $event)),
                        class: "form_input",
                        width: "100%"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  (Type.value === 'email')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: _unref(t)('myProfile.emailbox'),
                        prop: "email",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: telAndEmailInfo.email,
                            "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((telAndEmailInfo.email) = $event)),
                            class: "form_input"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (Type.value === 'tel')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: _unref(t)('myProfile.newTel'),
                        prop: "mobile",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: telAndEmailInfo.mobile,
                            "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((telAndEmailInfo.mobile) = $event)),
                            placeholder: _ctx.$t('register.mobilePlaceholder'),
                            class: "form_input",
                            clearable: ""
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: telAndEmailInfo.mobile_zone,
                                "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((telAndEmailInfo.mobile_zone) = $event)),
                                placeholder: _unref(t)('common.pleaseSelect'),
                                filterable: "",
                                clearable: "",
                                style: {"width":"100px"},
                                onVisibleChange: selectFocus
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryCodeList.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: isFocus.value?(!isEnglish.value?item.label:item.labelen):item.zone_code,
                                      value: item.zone_code
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})